import {Component, Input} from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { PageService } from "../shared/page-service";
import { ActivityType, TalentProfilePage, TalentProfileStartAvailability } from "../../../enums";
import { TalentMoatsAvailabilityV2 } from "../../../../typings";
import { TalentProfileApiService } from "../talent-profile-api.service";
import { UtilService } from "../shared/util.service";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { sendDoThisLaterEmail } from "../../shared/util/talent-happy-path-util";

@Component({
  selector: 'app-employment-opportunities',
  standalone: false,
  templateUrl: './employment-opportunities.component.html',
  styleUrl: './employment-opportunities.component.scss'
})
export class EmploymentOpportunitiesComponent {

  opportunitiesForm: FormGroup;
  isInitialLoad: boolean = true;
  talentProfileStartAvailability = TalentProfileStartAvailability;
  availabilityDate: Date;
  talent: Talent;
  posting: PostingInfo;
  isModalVisible: boolean = false;

  @Input() fromNotAFit: boolean = false;

  constructor(
    private fb: FormBuilder,
    private talentProfileApiService: TalentProfileApiService,
    private pageService: PageService,
    private utils: UtilService,
    private talentHappyPathDataService: TalentHappyPathDataService
  ) { }

  ngOnInit(): void {
    this.opportunitiesForm = this.fb.group({
      activelySearchingSelected: [null],
      availabilityType: [0],
      numWeeksNoticeNeeded: [null],
      preAuthorizedSubmittal: [null],
      availabilityDate: [null]
    });

    this.talent = this.talentHappyPathDataService.talent;
    this.posting = this.talentHappyPathDataService.postingInfo;
    this.loadAvailability();

    this.opportunitiesForm.valueChanges.subscribe((values: TalentMoatsAvailabilityV2) => {
      if (!this.isInitialLoad) {
        this.saveAvailability(values);
      }
    });
  }

  loadAvailability() {
    this.talentProfileApiService.getEmploymentAvailability(this.talent.personId).subscribe(availability => {
      this.opportunitiesForm.patchValue(availability);
      this.isInitialLoad = false;
      this.availabilityDate = this.utils.stringToDate(availability.availabilityDate);
    });
  }

  saveAvailability(availability: TalentMoatsAvailabilityV2): void {
    availability = this.utils.filterTalentAvailability(availability);
    this.talentProfileApiService.saveEmploymentAvailability(availability, this.talent.personId).subscribe(response => {
      console.log('Availability saved', response);
    }, error => {
      console.error('Error saving availability', error);
    });
  }

  goToEmploymentPreferences() {
    this.pageService.setActivePage(TalentProfilePage.EMPLOYMENT_PREFERENCES);
  }

  getAvailabilityType(name: string) {
    if(name === 'now') {
      return TalentProfileStartAvailability.NOW;
    }
    if(name === 'withNotice') {
      return TalentProfileStartAvailability.WITH_NOTICE;
    }
    if(name === 'specificDate') {
      return TalentProfileStartAvailability.SPECIFIC_DATE;
    }
  }

  get availabilityType() {
    return this.opportunitiesForm.get('availabilityType');
  }

  onAvailabilityDateChange(newDate: Date) {
    this.availabilityDate = newDate;
    this.opportunitiesForm.patchValue({
      availabilityDate: this.utils.dateToString(newDate)
    });
  }

  doThisLater() {
    if (!this.talentHappyPathDataService.doThisLaterEmailSent) {
      sendDoThisLaterEmail(
        this.posting?.jobPostingId ?? null,
        this.talent.personId,
        this.talent.firstName,
        this.talent.lastName,
        this.talent.email,
        this.posting?.jobTitle ?? null,
        this.posting?.orderId ?? null,
        this.talentProfileApiService,
        this.talentHappyPathDataService.isGeneralApplication
      )
    }
  }

  goBack() {
    this.pageService.setActivePage(TalentProfilePage.EMPLOYMENT_SPLASH_PAGE);
  }

}
